"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@tiptap/react");
var react_svg_1 = require("react-svg");
var bold_svg_1 = __importDefault(require("./assets/bold.svg"));
var link_svg_1 = __importDefault(require("./assets/link.svg"));
var italic_svg_1 = __importDefault(require("./assets/italic.svg"));
var underline_svg_1 = __importDefault(require("./assets/underline.svg"));
var ol_svg_1 = __importDefault(require("./assets/ol.svg"));
var ul_svg_1 = __importDefault(require("./assets/ul.svg"));
var react_2 = require("@emotion/react");
var getCSSRules = function (_a) {
    var colors = _a.colors;
    return ({
        icon: {
            stroke: colors.Grey[0],
        },
        active: {
            stroke: colors.Hannibal[300],
        },
        button: {
            margin: '0 5px',
            backgroundColor: 'transparent',
            padding: 0,
            cursor: 'pointer',
            border: 'none',
            '& svg': { verticalAlign: 'middle' },
        },
        divider: {
            backgroundColor: colors.Grey[600],
            width: 1,
            height: 24,
            margin: '0 5px',
        },
        flex: {
            padding: '3px 0',
            display: 'flex',
            alignItems: 'center',
        },
    });
};
var MenuButton = function (_a) {
    var src = _a.src, _b = _a.active, active = _b === void 0 ? false : _b, onClick = _a.onClick;
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsx)("button", __assign({ css: (0, react_2.css)(styles.button), onClick: onClick }, { children: (0, jsx_runtime_1.jsx)(react_svg_1.ReactSVG, { css: (0, react_2.css)(active ? styles.active : styles.icon), src: src }, void 0) }), void 0));
};
var EditorMenu = function (_a) {
    var editor = _a.editor, toggleShowLink = _a.toggleShowLink, linkInput = _a.linkInput, onVisibilityChange = _a.onVisibilityChange, rest = __rest(_a, ["editor", "toggleShowLink", "linkInput", "onVisibilityChange"]);
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsxs)(react_1.BubbleMenu, __assign({ editor: editor, tippyOptions: {
            delay: 100,
            duration: 100,
            zIndex: 10000,
            onShow: function () {
                onVisibilityChange && onVisibilityChange(true);
            },
            onHide: function () {
                onVisibilityChange && onVisibilityChange(false);
            },
        } }, rest, { children: [linkInput, !linkInput && ((0, jsx_runtime_1.jsxs)("div", __assign({ css: (0, react_2.css)(styles.flex) }, { children: [(0, jsx_runtime_1.jsx)(MenuButton, { onClick: function () { return editor.chain().focus().toggleBold().run(); }, src: bold_svg_1.default, active: editor.isActive('bold') }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { src: italic_svg_1.default, active: editor.isActive('italic'), onClick: function () { return editor.chain().focus().toggleItalic().run(); } }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { src: underline_svg_1.default, active: editor.isActive('underline'), onClick: function () { return editor.chain().focus().toggleUnderline().run(); } }, void 0), (0, jsx_runtime_1.jsx)("div", { css: (0, react_2.css)(styles.divider) }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { src: ul_svg_1.default, active: editor.isActive('bulletList'), onClick: function () { return editor.chain().focus().toggleBulletList().run(); } }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { src: ol_svg_1.default, active: editor.isActive('orderedList'), onClick: function () { return editor.chain().focus().toggleOrderedList().run(); } }, void 0), (0, jsx_runtime_1.jsx)("div", { css: (0, react_2.css)(styles.divider) }, void 0), (0, jsx_runtime_1.jsx)(MenuButton, { src: link_svg_1.default, active: !!editor.getAttributes('link').href, onClick: function () { return toggleShowLink(true); } }, void 0)] }), void 0))] }), void 0));
};
exports.default = EditorMenu;
//# sourceMappingURL=Menu.js.map